import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-action-column-molecule',
  templateUrl: './action-column-molecule.component.html',
  styleUrls: ['./action-column-molecule.component.scss']
})
export class ActionColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() dynamicNormForm: FormGroup;
  @Output() dataEmitForDynamicNormReview = new EventEmitter<{}>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  constructor(private dialog: MatDialog) { }
  
  action(actionType, controlId) {
    if (actionType === "update") {
      this.dataEmitForDynamicNormReview.emit({
        status: "MODIFIED",
        id: controlId,
        newNormValue: this.dynamicNormForm.get(controlId).value,
      });
    } else {
      this.dataEmitForDynamicNormReview.emit({
        status: actionType,
        id: controlId,
      });
    }
  }
  onEdit(id: any, event: MouseEvent) {
    this.edit.emit({ id, event });
  }

  onDelete(id: any, event: MouseEvent) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete.emit({ id, event });
      }
    });
  }
}
